export default __webpack_public_path__ + "static/media/logo.159ad715.png";